import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import LandingCanvas from "../landingEditor/LandingCanvas";

export default function LandingStudioCanvasStage({
  form,
  device,
  productsEnabled,
  activeSection,
  saving,
  onSelectSection,
  onCommit,
  onCommitMany,
  onUploadImage,
  onRemoveImage,
  onOpenSegmentTool,
  onToggleSection,
}) {
  return (
    <Box
      component="main"
      sx={{
        position: "fixed",
        inset: {
          xs: "136px 0 calc(76px + env(safe-area-inset-bottom))",
          sm: "88px 0 139px",
        },
        overflow: "auto",
        bgcolor: device === "mobile" ? "#E8EBEF" : "#F4F5F7",
      }}
    >
      {saving ? (
        <Box
          sx={{
            position: "fixed",
            top: { xs: 146, sm: 98 },
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1150,
            px: 1.4,
            py: 0.65,
            borderRadius: 999,
            bgcolor: "rgba(25,36,47,.88)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 0.8,
            pointerEvents: "none",
          }}
        >
          <CircularProgress size={14} sx={{ color: "#fff" }} />
          <Typography variant="caption" sx={{ fontWeight: 850 }}>Guardando cambios</Typography>
        </Box>
      ) : null}

      <Box
        sx={{
          width: "100%",
          minHeight: "100%",
          py: device === "mobile" ? 2.5 : 0,
          px: device === "mobile" ? 1.5 : 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <LandingCanvas
          form={form}
          activeSection={activeSection}
          device={device}
          productsEnabled={productsEnabled}
          onSelectSection={onSelectSection}
          onCommit={onCommit}
          onCommitMany={onCommitMany}
          onUploadImage={onUploadImage}
          onRemoveImage={onRemoveImage}
          saving={saving}
          studioMode
          onOpenSegmentTool={onOpenSegmentTool}
          onToggleSection={onToggleSection}
        />
      </Box>
    </Box>
  );
}
